// mui
import { Stack, TextField } from '@mui/material';
//
import useResponsive from '@/hooks/useResponsive';
// redux
import { dispatch, useSelector } from '@/stores';
import { setNumberOfDesks } from '@/features/bookings-management/slices';
// types
import { ServiceFormField } from '@/types';

interface Prop {
  serviceFormField: ServiceFormField;
}

export default function NumberInputField({ serviceFormField }: Prop) {
  const downMd = useResponsive('down', 'md');
  const { numberOfDesks } = useSelector((state) => state.booking.cleanDetails);
  const isDesksField = serviceFormField.ref === 'desks';

  const handleValueChange = (value: string) => {
    if (isDesksField) {
      dispatch(setNumberOfDesks(value === '' ? 0 : Number(value)));
    }
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{ width: downMd ? '100%' : '75%' }}
    >
      <TextField
        fullWidth
        label={serviceFormField.name}
        type="number"
        value={isDesksField ? numberOfDesks : undefined}
        defaultValue={isDesksField ? undefined : serviceFormField.min_value}
        onChange={(event) => handleValueChange(event.target.value)}
        inputProps={{
          min: serviceFormField.min_value,
          max: serviceFormField.max_value,
          step: serviceFormField.increment_value || 1,
        }}
      />
    </Stack>
  );
}
